// extracted by mini-css-extract-plugin
module.exports = {"title":"g_j","chart-navigation":"g_k","chart-navigation__left":"g_l","chart-navigation__right":"g_m"};